<template>
    <button @click="$emit('click')"
        class="dashed-btn"
        :class="{'loading': loading}"
        :style="styles">
        <v-progress-circular
            data-testid="dashed-btn-loader"
            v-if="loading"
            indeterminate
            color="#e7e7e7"
        ></v-progress-circular>
        <slot v-else />
    </button>
</template>

<script>
export default {
    name: 'DashedBtn',
    props: {
        loading: {
            type: Boolean,
            required: false
        },
        backgroundColor: {
            type: String,
            required: false
        },
        height: {
            type: String,
            required: false,
            default: "80px"
        },
        borderColor: {
            type: String,
            required: false
        },
        textColor: {
            type: String,
            required: false
        }
    },
    computed: {
        styles() {
            const styles = { 'height': this.height}

            if (this.borderColor) styles['background-color'] = this.backgroundColor
            if (this.borderColor) styles["border"] = "1px dashed" + this.borderColor
            if (this.textColor) styles["color"] = this.textColor
            
            return styles
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.dashed-btn {
    width: 100%;
    border: 1px dashed $grey-color-8;
    background-color: $grey-color-1;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.12px;
    color: $navy-color-1;
    text-transform: uppercase;
    position: relative;
    transition-duration: 0.28s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    
    &::before {
        bottom: 0px;
        color: inherit;
        content: "";
        left: 0px;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0px;
        top: 0px;
        background-color: currentcolor;
        transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0s;
    }

    &:hover::before {
        opacity: 0.08;
    }

    &.loading {
        pointer-events: none;
    }
}
</style>